export default {
  province_list: {
    110000: "黄金",
    120000: "铂金",
    130000: "钯金",
    140000: "白银"
  },
  city_list: {
    110100: "",
    110200: "",
    120100: "",
    120200: "",
    130100: "",
    130100: "",
    140100: "",
    140200: ""
  },
  county_list: {
    110101: "黄金金条9999",
    110102: "黄金金条999",
    // 110103: "黄金首饰999",
    110104: "黄金18K 750",
    110105: "黄金(无法确定)",
    // 铂金
    120101: "铂金板料9996",
    120102: "铂金首饰999",
    120103: "铂金首饰990",
    120104: "铂金首饰950",
    120105: "铂金(无法确定)",
    // 钯金
    130101: "钯金板料9996",
    130102: "钯金首饰999",
    130103: "钯金首饰990",
    130104: "钯金首饰950",
    130105: "钯金(无法确定)",
    // 白银
    140101: "白银板料9999",
    140102: "白银首饰999",
    140103: "白银首饰990",
    140104: "白银首饰925",
    140105: "白银(无法确定)"
  }
};
